import Person from "../components/Person";

export default function AlertPriseDeParole({ peer, idx }) {
  return (
    <>
      {/* Desktop : bas-gauche dans le conteneur video */}
      <div
        className="bg-warning shadow-lg d-none d-md-flex"
        style={{
          height: "50px",
          padding: "8px",
          minWidth: "100px",
          position: "absolute",
          bottom: `${12 + idx * 58}px`,
          left: "16px",
          zIndex: 20,
          borderRadius: "10px",
          color: "#000",
          fontSize: "20px",
          alignItems: "center",
        }}
      >
        <Person
          animate="mon-composant-meet-video-smallImg animate__animated animate__pulse animate__infinite"
          person={{
            image: peer.userImage,
            nom: peer.nom,
            prenom: peer.prenom,
            userId: peer.userId,
            colors: peer.color,
          }}
        />
        <span
          style={{
            marginLeft: "10px",
            marginRight: "20px",
            display: "inline-flex",
          }}
        >
          <span className="fs-1 animate__animated animate__wobble animate__infinite">
            🖐🏾
          </span>
        </span>
      </div>

      {/* Mobile : bas-gauche dans le conteneur video */}
      <div
        className="bg-warning shadow-lg d-flex d-md-none"
        style={{
          height: "50px",
          padding: "8px",
          minWidth: "100px",
          position: "absolute",
          bottom: `${12 + idx * 58}px`,
          left: "8px",
          zIndex: 20,
          borderRadius: "10px",
          color: "#000",
          fontSize: "20px",
          alignItems: "center",
        }}
      >
        <Person
          animate="mon-composant-meet-video-smallImg animate__animated animate__pulse animate__infinite"
          person={{
            image: peer.userImage,
            nom: peer.nom,
            prenom: peer.prenom,
            userId: peer.userId,
            colors: peer.color,
          }}
        />
        <span
          style={{
            marginLeft: "10px",
            marginRight: "20px",
            display: "inline-flex",
          }}
        >
          <span className="fs-1 animate__animated animate__wobble animate__infinite">
            🖐🏾
          </span>
        </span>
      </div>
    </>
  );
}
